import ConfigService from './configurationService';
/**
 * TODO: Abstract fetch code into HTTP-client wrapper once ajaxWrapper is removed.
 */
const defaultHeaders = {
    'Accept': 'application/json'
};

const isContentTypeJson = headers => {
    const contentType = (headers instanceof Headers) ? headers.get('content-type') : (headers['Content-Type'] || headers['content-type']);
    return contentType.includes('application/json');
};

const api = ({ url, method, body, headers = defaultHeaders }, options = {}) => {
    const source = new AbortController();
    const config = {
        method, headers,
        signal: source.signal,
        /**
     * For now, accept any additional options to pass through to fetch.
     */
        ...options
    };

    if (body !== undefined) {
        Object.assign(config, {
            body: isContentTypeJson(headers) ? JSON.stringify(body) : body
        });
    }

    const request = fetch(url, config);

    return Object.assign(request, {
        abort: source.abort
    }).then(response => {
        const {status} = response;
        // TODO: change to response.ok once Chrome for Android supports it.
        if (status >= 200 && status < 300) {
            return isContentTypeJson(response.headers)
                ? response.json()
                : response.text();
        } else {
            // TODO: implement
            // const error = new deriveErrorClassFromStatus(status)(response.statusText);
            throw Object.assign(new Error(response.statusText), {response});
        }
    });
};

export default {
    regexes: {
        email: /^([\w!#$%&'*+/=?^_`{|}~-]+(\.[\w!#$%&'*+/=?^_`{|}~-]+)*)+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])*$/
    },
    email (email) {
        return api({
            method: 'GET',
            url: `${ConfigService.getMarketConfig().siteUrl}/validate-service/api/v1/email/address.json?address=${email}`
        })
            .then(response => response.valid)
            .catch(error => {
                console.log(error);
                /**
         * If the service call fails, assume the email the user entered is valid
         * so that we don't block valid emails just because the service is down.
         * */
                return true;
            });
    }
};
